import * as _ from 'lodash';
/* eslint-disable @typescript-eslint/naming-convention */

export interface infoContoDeposito {
  code: string;
  description: string;
  letter: string;
  default: boolean;
  editable: boolean;
}


export const config = {
  env: 'production',
  version: 'V1.8.6',
  db: 61,
  confDeposito : [
    {code : '0', description: 'Standard', letter: 'A', default: false , editable: true},
    {code : '1', description: 'Esclusivamente conto deposito', letter: 'D', default: true , editable: false},
    {code : '2', description: 'Preferibilmente conto deposito', letter: 'D', default: true , editable: true},
    {code : '3', description: 'Esclusivamente conto assoluto', letter: 'A', default: false , editable: false},
    {code : '4', description: 'Preferibilmente conto assoluto', letter: 'A', default: false , editable: true},
    {code : '5', description: 'Ordini interni', letter: 'A', default: false , editable: true},
    {code : '6', description: 'Esclusivamente conto visione', letter: 'D', default: true , editable: false},
    {code : '7', description: 'Preferibilmente conto visione', letter: 'D', default: true, editable: true},
    {code : '8', description: 'Esclusivamente conto estimatorio', letter : 'D', default: true, editable: false},
    {code : '9', description: 'Preferibilmente conto estimatorio', letter : 'D', default: true, editable: true}
  ],

  //ENVIROMENT CDA

  local: {
    client_id: 2,
    client_secret: 'cNEUbIpEzjWZqwWZ5xw8ccyZQqZEcNdAea0R6Go8',
    oauth_base_url: 'http://127.0.0.1:8000/oauth',
    auth_base_url: 'http://127.0.0.1:8000/api/auth',
    base_url: 'http://127.0.0.1:8000/api',
    domain: 'http://127.0.0.1:8000',
    version: 'v1',
  },

  production: {
    client_id: 2,
    client_secret: 'cNEUbIpEzjWZqwWZ5xw8ccyZQqZEcNdAea0R6Go8',
    oauth_base_url: 'https://portalecda-api.dscsrl.it:8000/oauth',
    auth_base_url: 'https://portalecda-api.dscsrl.it:8000/api/auth',
    base_url: 'https://portalecda-api.dscsrl.it:8000/api',
    domain: 'https://portalecda-api.dscsrl.it:8000',
    version: 'v1',
  },
  test: {
    client_id: 2,
    client_secret: 'cNEUbIpEzjWZqwWZ5xw8ccyZQqZEcNdAea0R6Go8',
    oauth_base_url: 'http://172.16.0.178:8000/oauth',
    auth_base_url: 'http://172.16.0.178:8000/api/auth',
    base_url: 'http://172.16.0.178:8000/api',
    domain: 'http://172.16.0.178:8000',
    version: 'v1',
  },

};

export const contiDeposito = (conto) => {
  const data = [];
  config.confDeposito.forEach((item: infoContoDeposito) => {
       data.push(item.description);
  });
  return data;
};

export const contoDepositoInfo = (codice): infoContoDeposito => {

  const record = _.find(config.confDeposito, {code : codice});
  return record;
};

export const  formatBytes = (bytes, decimals = 2) => {
  if (!+bytes) { return '0 Bytes';}

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

